import { defineComponent as _defineComponent } from 'vue'
import { nextTick } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'EntrySheetEducationalResetDialog',
  props: {
    value: { type: Boolean }
  },
  emits: ["input", "confirm"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: boolean): void
  (e: 'confirm'): void
}), expose: any, slots: any, attrs: any }) {





function onOpened() {
  nextTick(() => {
    document
      .querySelectorAll('.entry-sheet-educational-reset-dialog__container')
      .forEach((el) => {
        ;(el as HTMLElement).scrollTop = 0
      })
  })
}

function onConfirm() {
  emit('input', false)
  emit('confirm')
}

return { __sfc: true,emit, onOpened, onConfirm }
}

})